
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { Physicals } from '../../canvas/entities/Physicals';
import { TaskCard } from './TaskCard';

export const createTaskCard = defineCommand(
    'createTaskCard',
    'Create: Task Card',
    (r) => {
        Physicals.createAtCameraPosition(r, TaskCard, nc => {
            nc.width = nc.layout.width;
            nc.height = nc.layout.height;
        });
    }
);

export const inTaskCardCommands = () => inCommands(
    createTaskCard,
);

